import { isEmpty } from 'lodash';
import PropTypes from 'prop-types';
import React from 'react';

import InputText from 'commons-forms/components/InputText/InputText.jsx';

import StringUtilService from 'commons-forms/services/StringUtilService/StringUtilService.js';
import ValidationService from 'commons-forms/services/ValidationService/ValidationService.js';

import FIELD_LENGTH from 'commons-forms/constants/fieldLength.js';

class InputZipCode extends React.Component {
    constructor(props) {
        super(props);

        this.handleInputChange = this.handleInputChange.bind(this);
        this.validInput = this.validInput.bind(this);
    }

    validInput(value) {
        const trimValue = StringUtilService.removeSpaces(value);
        const validation = ValidationService.validateZipCode(trimValue, this.props.country);

        if (this.props.isRequired) {
            return validation && ValidationService.validateIsNotEmpty(trimValue);
        }

        return isEmpty(value) || validation;
    }

    handleInputChange(value) {
        const maskValue = StringUtilService.formatPostalCode(value, this.props.country);

        this.props.onChange({
            value: maskValue,
            validation: this.validInput(maskValue),
        });
    }

    render() {
        return (
            <InputText
                type="text"
                name="postalCode"
                classNames={this.props.classNames}
                label={this.props.label}
                errorLabel={this.props.errorLabel}
                value={StringUtilService.formatPostalCode(this.props.value, this.props.country)}
                isRequired={this.props.isRequired}
                isValid={this.props.isValid}
                valueChange={this.handleInputChange}
                hasBeenSubmit={this.props.hasBeenSubmit}
                maxLength={FIELD_LENGTH.POSTAL_CODE_MAX}
            />
        );
    }
}

InputZipCode.defaultProps = {
    classNames: [],
    errorLabel: '',
    isRequired: false,
    hasBeenSubmit: false,
    country: 'ca',
};

InputZipCode.propTypes = {
    isValid: PropTypes.bool.isRequired,
    classNames: PropTypes.arrayOf(PropTypes.string),
    errorLabel: PropTypes.string,
    isRequired: PropTypes.bool,
    onChange: PropTypes.func.isRequired,
    label: PropTypes.string.isRequired,
    hasBeenSubmit: PropTypes.bool,
    value: PropTypes.string.isRequired,
    country: PropTypes.string,
};

InputZipCode.displayName = 'InputZipCode';

export default InputZipCode;
